export default {
  insertYxFinanceLoan: '/ygsjzs/yxFinanceLoan/insertYxFinanceLoan',
  updateYxFinanceLoan: '/ygsjzs/yxFinanceLoan/updateYxFinanceLoan',
  deleteDataYxFinanceLoan: '/ygsjzs/yxFinanceLoan/deleteDataYxFinanceLoan',
  selectYxFinanceLoanByLoanId: '/ygsjzs/yxFinanceLoan/selectYxFinanceLoanByLoanId',
  selectYxFinanceLoanByPage: '/ygsjzs/yxFinanceLoan/selectYxFinanceLoanByPage'
}
